
import { lazy } from 'react';
import PublishUtils from '../../../helpers/PublishUtils';
import WidgetCategory from '../../WidgetCategory';

class BBPMermaidDescriptor {
  

  static getDescription() {
    return {
      name: 'BBMermaid',
      component: lazy(() =>  import('./BBMermaid')),
      label: 'Diagram via Mermaid (BBPMermaid) (Experimental)',
      category: WidgetCategory.experimental,
      variables: [
        
        {
          name: 'mermaid',
          type: 'json-text',
          label:
            'mermaid string',
        }
        
      ],
    }
  }

  
}

export default BBPMermaidDescriptor
